import React, {useEffect, useState} from "react";
import {jwtDecode} from "jwt-decode";
import {useInView} from "react-intersection-observer";
import useGetAllMentionedPost from "../../hooks/useGetAllMentionedPost";
import AdminPostCard from "../postCard/AdminPostCard";
import Spinner from "../spinner/Spinner";
import PostCard from "../postCard/PostCard";
import {PostCardDetailsProps, TokenPayload} from "../../types/ComponentProps";
import LikesModal from "../likesModal/LikesModal";
import ImagePostModal from "../imagePostModal/ImagePostModal";
import {useImagePostModal} from "../../context/ImagePostModalContext";

const MentionedTab = () => {
  const {ref, inView} = useInView();
  const {isOpen: imagePostModalIsOpen} = useImagePostModal();

  const userDetails = jwtDecode<TokenPayload>(
    JSON.stringify(localStorage.getItem("accessTokenGC"))
  );
  const {
    isFetchingNextPage,
    isLoading,
    fetchNextPage,
    hasNextPage,
    allMentionedList,
  } = useGetAllMentionedPost(Number(userDetails?.id));

  const [selectedCardModal, setSelectedCardModal] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState<any>(null);

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, fetchNextPage, hasNextPage]);

  return (
    <>
      {selectedCardModal ? (
        <LikesModal
          post={selectedCard}
          setSelectedCardModal={setSelectedCardModal}
        />
      ) : null}

      {imagePostModalIsOpen ? <ImagePostModal /> : null}

      {isLoading ? (
        <Spinner alignSpin="center-spinner" variant="medium-spinner" />
      ) : allMentionedList?.pages[0]?.posts.length === 0 ? (
        <p className="not-available-blk">No posts available</p>
      ) : (
        allMentionedList?.pages.map((page, index) => (
          <React.Fragment key={index}>
            {page.posts.map((post: PostCardDetailsProps, index: number) =>
              post?.badgeId ? (
                <AdminPostCard key={index} post={post} />
              ) : (
                <PostCard
                  key={index}
                  post={post}
                  setSelectedCardModal={setSelectedCardModal}
                  setSelectedCard={setSelectedCard}
                />
              )
            )}
          </React.Fragment>
        ))
      )}
      <div ref={ref}>
        {isFetchingNextPage ? (
          <Spinner alignSpin="center-spinner" variant="medium-spinner" />
        ) : hasNextPage ? null : !isLoading &&
          allMentionedList?.pages?.[0]?.posts?.length !== 0 ? (
          <div className="all-posts-label-blk">
            <div></div>
            <p>You have seen all the posts</p>
            <div></div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default MentionedTab;
